module.exports = __webpack_public_path__ + "static/img/shop_head_bg.be8d49cd.png";